export default "__VITE_ASSET__3h2Rl91K__"